import React, { useImperativeHandle } from 'react';

import { useTheme } from '@material-ui/core/styles';

const StripeInput = props => {
  const [mountNode, setMountNode] = React.useState(null);
  
  const {
    component: Component,
    inputRef,
    onChange,
    onFocus,
    onBlur
  } = props;

  useImperativeHandle(inputRef, () => ({
    focus: () => mountNode.focus()
  }), [mountNode]);

  const theme = useTheme();
  
  return (
    <Component
      onReady={setMountNode}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      className="MuiInputBase-input"
      style={{
        base: {
          color: theme.palette.text.primary,
          fontSize: `${theme.typography.htmlFontSize}px`,
          fontFamily: theme.typography.fontFamily
        },
        invalid: {
          color: theme.palette.text.primary
        }
      }}
      placeholder=""
    />
  );
}

export default StripeInput;